import { faWarning } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { history } from "app/tools/history"
import { messageSVC } from "message/service"
import { NOT_FOUND_PATH } from "page/model"
import { setMenuExpansion } from "ui/tools/menu"
import { isPhoneScreen } from "ui/tools/responsive"
import { getActivePage, getPageByPath } from "./common"

interface INavigateParams {
  path: string
  pathParams?: Array<string | number> | string | number
  queryParams?: string
  hashParams?: Array<[string, string]>
  ignoreLeavingMessage?: boolean
}

export function navigate(params: INavigateParams | string | -1): void {
  const currentPage = getActivePage()
  if (currentPage && currentPage.confirmLeaving && (typeof params !== "object" || !params.ignoreLeavingMessage)) {
    const toDisplayLeavingMessage = currentPage.confirmLeaving()
    if (toDisplayLeavingMessage) {
      messageSVC.confirmMessage({
        title: translate("page.leave.title"),
        message: toDisplayLeavingMessage,
        addGenericConfirmMessage: true,
        icon: faWarning,
        onSuccess: () => processNavigate(params)
      })
    } else {
      processNavigate(params)
    }
  } else {
    processNavigate(params)
  }
}

function processNavigate(params: INavigateParams | string | -1): void {
  if (!params) {
    history.push(NOT_FOUND_PATH)
    messageSVC.error("Missing path")
    return
  }
  if (isPhoneScreen()) {
    setMenuExpansion(false)
  }
  if (params === -1) {
    history.back()
    return
  }
  if (typeof params === "string") {
    params = { path: params }
  }
  let { path, pathParams } = params
  const { queryParams, hashParams } = params
  const page = getPageByPath(path)
  if (page.path === NOT_FOUND_PATH) {
    history.push(NOT_FOUND_PATH)
    return
  }
  if (page.params) {
    if (typeof pathParams === "string") {
      pathParams = [pathParams]
    } else if (typeof pathParams === "number") {
      pathParams = [String(pathParams)]
    }
    if (!pathParams || page.params.length !== pathParams.length) {
      history.push(NOT_FOUND_PATH)
      messageSVC.error("Missing path parameters")
      return
    }
    for (let i = 0; i < page.params.length; i++) {
      const paramId = page.params[i]
      const paramValue = pathParams[i]
      path = path.replace(paramId, String(paramValue))
    }
  }
  if (queryParams) {
    path += queryParams
  }
  if (Array.isArray(hashParams) && hashParams.length > 0) {
    let hashParam = hashParams.shift() as any
    path += `#${hashParam[0]}=${hashParam[1]}`
    for (hashParam of hashParams) {
      path += `&${hashParam[0]}=${hashParam[1]}`
    }
  }
  history.push(path)
}
